export default "__VITE_ASSET__40df1d1c__"